import React from 'react'
import { SobreWrapper } from './style'
import { Col, Label, Row } from 'reactstrap'
import Missao from './components/Missao'
import { CorpoConteudo } from 'layouts/simple/style'
import PapelSocial from './components/PapelSocial'
import Navbar from 'components/Navbar'
import { HashLink } from 'react-router-hash-link'
import FooterSobre from 'components/Footer/FooterSobre'

const Sobre = () => {
  return (
    <>
      <Navbar />
      <CorpoConteudo>
        <SobreWrapper>
          <div className="container">
            <h1>Muito prazer, nós somos a Riber</h1>
            <Row>
              <Col md={6}>
                <section>
                  <h2>
                    Acreditar transforma. Confiar <br /> impulsiona. Realizar é
                    possível.
                  </h2>
                  <div className="d-flex flex-column gap-4 mb-4">
                    <p className="text">
                      Todos os dias, milhares de pessoas enfrentam desafios,
                      tomam decisões e sonham com uma vida mais tranquila,
                      segura e cheia de conquistas. E é para elas que existimos.
                    </p>
                    <p className="text">
                      Na Riber, acreditamos no poder da oportunidade. Sabemos
                      que um gesto de confiança, um atendimento acolhedor ou uma
                      solução acessível pode mudar o rumo de uma história.
                    </p>
                    <p className="text">
                      Porque mais do que crédito, entregamos possibilidades.
                      Mais do que números, enxergamos pessoas. E é por isso que,
                      há mais de 24 anos, seguimos firmes no nosso propósito:
                      ser ponte entre planos e realizações.
                    </p>
                    <p className="text">
                      Se você pode sonhar, a gente pode ajudar a conquistar.
                    </p>
                  </div>
                </section>
              </Col>
              <Col className="d-flex align-items-stretch" md={6}>
                <aside className="d-flex justify-content-center align-items-center">
                  <Row className="d-flex row-gap-20">
                    <Col className="d-flex flex-column gap-4" md={6}>
                      <HashLink
                        className="link"
                        to="/sobre#missao-visao-valores"
                      >
                        <img
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/sobre_1.png"
                          height={90}
                        />
                      </HashLink>
                      <Label className="label-link">
                        Missão, Visão e Valores
                      </Label>
                    </Col>
                    <Col className="d-flex flex-column gap-4" md={6}>
                      <HashLink className="link" to="/#riber-perto">
                        <img
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/sobre_2.png"
                          height={90}
                        />
                      </HashLink>
                      <Label className="label-link">Nossa Presença</Label>
                    </Col>
                    <Col className="d-flex flex-column gap-4" md={6}>
                      <HashLink className="link" to="">
                        <img
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/sobre_3.png"
                          height={90}
                        />
                      </HashLink>
                      <Label className="label-link">Código de ética</Label>
                    </Col>
                    <Col className="d-flex flex-column gap-4" md={6}>
                      <HashLink className="link" to="/sobre#papel-social">
                        <img
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/sobre_4.png"
                          height={90}
                        />
                      </HashLink>
                      <Label className="label-link">
                        Projetos que apoiamos
                      </Label>
                    </Col>
                  </Row>
                </aside>
              </Col>
            </Row>
          </div>
          <Missao />
          <PapelSocial />
        </SobreWrapper>
      </CorpoConteudo>
      <FooterSobre />
    </>
  )
}

export default Sobre
